/**
 * SPA на mailalert.* отдаётся только для Gmail-алертов; остальная админ-навигация ведёт на основной домен.
 * Доп. хост: VITE_MAIL_ALERT_HOSTNAME (если отличается от mailalert.alex-digital.io).
 */
function mailAlertHostnames(): Set<string> {
  const s = new Set(['mailalert.alex-digital.io'])
  const extra = (import.meta.env as { VITE_MAIL_ALERT_HOSTNAME?: string }).VITE_MAIL_ALERT_HOSTNAME
  const h = (typeof extra === 'string' ? extra : '').trim().toLowerCase()
  if (h) s.add(h)
  return s
}

const DEFAULT_MAIN_PORTAL = 'https://alex-digital.io'

export function isMailAlertOnlyHost(): boolean {
  if (typeof window === 'undefined') return false
  return mailAlertHostnames().has(window.location.hostname.toLowerCase())
}

function mainPortalOrigin(): string {
  const raw = (import.meta.env as { VITE_MAIN_PORTAL_ORIGIN?: string }).VITE_MAIN_PORTAL_ORIGIN
  const s = (typeof raw === 'string' ? raw : '').trim()
  return (s || DEFAULT_MAIN_PORTAL).replace(/\/$/, '')
}

/**
 * Путь для навигации: на основном домене — относительный; на mailalert — абсолютный URL портала.
 * Путь вида /admin/mail-alert оставляем относительным, чтобы не уводить с поддомена почты.
 */
export function adminNavTo(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`
  if (!isMailAlertOnlyHost()) return p
  if (p === '/admin/mail-alert' || p.startsWith('/admin/mail-alert?')) return p
  return `${mainPortalOrigin()}${p}`
}
